import React, { Component } from "react";
import { Dropdown } from 'primereact/dropdown';
import axios from "axios";
import {config} from "../shared/config";
import * as util from '../shared/commons';
export default class TeacherSchoolClassCourseCombo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items:[],
            loading:true,
            courseId:props.courseId,
            schoolClassId:props.schoolClassId,
        }
    }
    componentDidMount = ()=>{
        this.reloadItems();
    }
    reloadItems = () =>{
      var params = {login:util.getTrustedUser(), lastIndex: 0, pageSize: 0, includeTeacher:true, includeAssistant:true, searchText:"" };
      var url = config.Server+`/school/timing/teacher/school-class-course/list`;
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  

                var items = [];
                for(var i=0;i<response.length;i++){
                    var id = response[i].schoolClass.id + "_" + response[i].course.id;
                    var title = response[i].schoolClass.name + "-" + response[i].course.name;
                    var r = {"id":id, "OptionTitle":title, "OptionValue":id, itemValue:response[i]};
                    items.push(r);           
                } 
                var newState = {...this.state};

                newState["loading"] = false;

                newState["items"] = items;

                this.setState(newState);                 
                  
              }
              else{
                  
              }
          })
          .catch(error => {
              
          });
    } 
    onInputChange = (e) => {
        var val = e;
        if(val){
            val = val.itemValue; 
        console.log("val is>", val)
            this.props.onChange(val);            
            var ns = {...this.state};
            ns["schoolClassId"]  = val.schoolClass.id;          
            ns["courseId"]  = val.course.id; 
            this.setState(ns);         
        }
        else{
            this.props.onChange(null); 
            var ns = {...this.state};
            ns["schoolClassId"]  = "";          
            ns["courseId"]  = ""; 
            this.setState(ns);         
        }
    }
    getItemIndex = (items, schoolClassId, courseId) =>{
        if(schoolClassId == null)return -1;
        if(schoolClassId == "")return -1;
        if(courseId == null)return -1;
        if(courseId == "")return -1;
        if(items === null) return -1;
        if(items.length === 0) return -1;
        for(var i=0;i<items.length;i++){
            if((items[i].itemValue.schoolClass.id == schoolClassId)&&(items[i].itemValue.course.id == courseId)) return i;            
        }
        return -1;
    }

    render() { 
        var ind = this.getItemIndex(this.state.items, this.state.schoolClassId, this.state.courseId);
        var ci = null;
        if(ind >=0) ci = this.state.items[ind];
        var visible = true;
        if(this.props.visible === false)
                visible = false;
        var display = "block";
        if(!visible) display = "none";

        return (
            <>
                <div className="field" style={{display:display}}>
                    <label className="font-bold" style={{width:"100%"}}>
                        کلاس - درس
                    </label>
                    <Dropdown scrollHeight="350px" disabled={this.props.disabled} value={ci} onChange={(e) => this.onInputChange(e.value)} options={this.state.items} optionLabel="OptionTitle"
                        placeholder={"کلاس-درس را انتخاب کنید"} className="w-full" checkmark={true} highlightOnSelect={true} filter showClear  style={{width:"100%"}} loading={this.state.loading}/>
                </div>
            </>
        );
    }
}
 
